import React, { useState } from 'react'
import styled from 'styled-components'
import { FaTimes } from 'react-icons/fa'
import { Box, Button, Icon, SimpleModal, ConfirmButton } from '@/components/lib'

const StyledImage = styled.img`
  max-width: 100%;
  max-height: 400px;
  margin: 10px auto;
  display: block;
`

const StyledModalImage = styled.img`
  margin: 10px auto;
  display: block;
`

const StyledPreview = styled(Box)`
  background-position: center center;
  background-size: cover;
  background-image: url(${props => props.src});
`

function Image ({ url, withPreview, onRemove }) {
  const [openFull, setOpenFull] = useState(false)

  if (!url) return null
  return (
    <>
      {withPreview
        ? (
          <Box>
            <Box p={2}>
              <StyledPreview
                src={url} onClick={() => setOpenFull(true)}
                shadow='md' rounded='md' cursor='pointer' w='100px' h='100px'
                transition='0.25s' _hover={{ shadow: 'lg' }}
              />
            </Box>

            <SimpleModal
              modalProps={{ size: '5xl' }} isOpen={openFull} onClose={() => setOpenFull(false)}
              body={<StyledModalImage src={url} />}
            />
          </Box>)
        : (
          <Box display='flex' justifyContent='center' mt={5}>
            <Box p={3} bg='bg.surface' minWidth='400px' maxWidth='80%' rounded='md' shadow='md'>
              {onRemove &&
                <Box mb={3} display='flex' justifyContent='end'>
                  <ConfirmButton
                    header='Really remove this image?'
                    trigger={<Button variant='ghost'><Icon as={FaTimes} mr={2} /> Remove</Button>}
                    onConfirm={onRemove}
                  />
                </Box>}
              <StyledImage src={url} />
            </Box>
          </Box>)}
    </>
  )
}

export default Image
